import React from 'react';
import './App.css';
import HomeScreen from './screens/HomeScreen';

function App() {
  return (
    <div className="App">
      <HomeScreen/>
    </div>
  );
}

export default App;
